import React from 'react';
import { connect } from 'react-redux';
import listUtils from '../../../utils/listUtils';
import { loadData } from '../../../utils/ActionCreators';
import { contentType } from '../../../utils/ActionTypes';
import { ComponentText } from '../../shared/ComponentText';
import utils from '../../../utils/utils';
import { RangeDateTimePicker } from '../../shared/DateTime/RangeDateTimePicker';
import {
  metricsRevenueApiPath,
  metricsRevenuePath,
} from '../../../utils/routerUtils';
import { getUser } from '../../../utils/Repository';
import { Row } from 'antd';
import ComponentAppSelect from '../../shared/ComponentAppSelect';
import Space from '../../shared/Spcae';
import './MetricsRevenue.css';
import { localStorageKey } from '../../../utils/LocalStorage';
import RechartChart, {
  DEFAULT_MIN_DURATION,
  getInterval,
} from '../../shared/Chart/RechartChart';
import { ChartSegmentTable } from '../../shared/Chart/ChartSegmentTable';

const path = metricsRevenueApiPath;
const title = 'Revenue';

class MetricsRevenue extends React.Component {

  componentDidMount() {
    this.loadListWithPageFilter();
  }


  componentDidUpdate (previousProps, prevState, snapshot) {
    const currentSearch = this.props.location.search;
    const previousSearch = previousProps.location.search;
    if (currentSearch !== previousSearch) {
      this.loadListWithPageFilter();
    }

    if(this.props.message && this.props.message !== previousProps.message){
      const text = this.props.message.error.charAt(0).toUpperCase() + this.props.message.error.slice(1);
      utils.showError(text);
    }
  }

  loadListWithPageFilter() {
    const { onLoadData } = this.props;



    const user = getUser();
    const query = new URLSearchParams(this.props.location.search);
    const applicationId = query.get('application_ids');
    const bucketInterval = query.get('bucket_interval');

    const from = query.get('from');
    const to = query.get('to');
    const between = utils.getDefaultDateRange(from, to);

    let duration = utils.getDateRangeDuration(between.from,between.to);

    let x = listUtils.currentFilters(this.props.location.search, []);
    let filters = listUtils.prepareFilterParamsWithDate(listUtils.prepareFilterParams(x), between);

    if(bucketInterval){
      filters['bucket_interval'] = bucketInterval;
    }else{
      const interval = localStorage.getItem(localStorageKey.METRICS_INTERVAL);
      filters['bucket_interval'] = getInterval(duration, interval);
    }
    if(applicationId) {
      if (applicationId && applicationId !== 'all-app') {
        filters['application_id'] = applicationId;
      }
      filters['organization_id'] = user.organizations_roles[0].organization_id;
      onLoadData(contentType.METRICS_REVENUE, path, { filters: filters });
    }
  }

    onDateChanged = range => {
      const between = { from: range.from, to: range.to };
      const { history } = this.props;
      let filters = listUtils.prepareFilterParamsWithDate(
        listUtils.prepareFilterParams(listUtils.currentFilters(this.props.location.search, [])),
        between,
      );
      history.push(listUtils.prepareUrlWithoutPager(metricsRevenuePath, filters));
    };

    render() {
      let { isFetching, data, message } = this.props;

      const blur = message && message.code && message.code === 426;


      // let series = [ {
      //   name: 'series-1',
      //   data: []}
      // ];
      // let categories = [];

      let chartData = [];
      if(data){
        data.forEach(e => {
          chartData.push({
            value: Math.round(e.value),
            date: e.key
          });
        });
      }
      return (
        <div className={"metrics-container"}>
          <Row type="flex" justify="space-between" align="middle">
            <Row type="flex">
              <ComponentText
                text={title}
                size="28"
                weight="600"
                color="#212b36"
                align="left"
                marginTop="0"
                marginBottom="0"
              />
            </Row>
            <Row type="flex">
              <ComponentAppSelect location={this.props.location} history={this.props.history} />
              <Space width="16" />
              <RangeDateTimePicker
                onDateChanged={this.onDateChanged}
                location={this.props.location}
                history={this.props.history}
                defaultInterval={DEFAULT_MIN_DURATION}
              />
            </Row>
          </Row>

          {/*<ApexBarChart series={series} categories={categories} location={this.props.location} history={this.props.history} />*/}
          <RechartChart blur = {blur} data={chartData} location={this.props.location}
            history={this.props.history}
            isFetching={isFetching}
            titles={chartTitles} keys={chartValueKeys} colors={chartColors}/>
          <Space height={20}/>
          {!blur && <ChartSegmentTable list={chartData} isFetching={isFetching}
            isStacked={false} titles={chartTitles} keys={chartValueKeys}/>}
          <Space height={20} />
        </div>
      );
    }
}

const chartTitles = ["Revenue"];
const chartValueKeys = ["value"];
const chartColors = ["#26c1c9"];

const mapActionToProps = {
  onLoadData: loadData,
};

const mapStateToProps = state => {
  const { metricsRevenueRemoteData } = state;
  return {
    data: utils.getMetrics(metricsRevenueRemoteData),
    isFetching: utils.getIsFetching(metricsRevenueRemoteData),
    isFailed: utils.getIsFailed(metricsRevenueRemoteData),
    message: utils.getMessage(metricsRevenueRemoteData),
  };
};
export default connect(mapStateToProps, mapActionToProps)(MetricsRevenue);

